import { useState, useEffect, useMemo } from "react";
import Nav from "./components/Nav";
import Video from "./components/Video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { addAction } from "./utils/firebase/actions";
function App() {
  const INCREASE_YEARS_INTERVAL = 2000;
  const MIN_YEAR = 0;
  const INITIAL_YEARS = 20;
  const MIN_COUNTER = 0;
  const INITIAL_COUNTER = 12;

  const [year, setYear] = useState(INITIAL_YEARS);
  const [counter, setCounter] = useState(INITIAL_COUNTER);
  const [videoVisiblity, setVideoVisiblity] = useState(false);
  useEffect(() => {
    const incrreaseYearsInterval = setInterval(() => {
      let newValue = year - 1;
      if (newValue <= MIN_YEAR) {
        newValue = INITIAL_YEARS;
      }
      setYear(newValue);
    }, INCREASE_YEARS_INTERVAL);
    return () => {
      clearInterval(incrreaseYearsInterval);
    };
  }, [year]);

  useEffect(() => {
    const incrreaseCounterInterval = setInterval(() => {
      let newValue = counter - 1;
      if (newValue <= MIN_COUNTER) {
        newValue = INITIAL_COUNTER;
      }
      setCounter(newValue);
    }, INCREASE_YEARS_INTERVAL / INITIAL_COUNTER);

    return () => {
      clearInterval(incrreaseCounterInterval);
    };
  }, [counter]);

  useEffect(() => {
    if (!videoVisiblity) {
      reset();
    }
  }, [videoVisiblity]);

  const ageform = useMemo(() => {
    return `${year.toString().length > 1 ? year : "0" + year}:${counter.toString().length > 1 ? counter : "0" + counter}`;
  }, [counter, year]);

  const reset = () => {
    setCounter(INITIAL_COUNTER);
    setYear(INITIAL_YEARS);
  };

  return (
    <>
      <section className="App">
        <section className="app-content">
          <div className="timer-container">
            <div className="timer">
              <button onClick={reset}>
                <FontAwesomeIcon icon={faRotateLeft} />
              </button>
              <div className="years">
                <p>Years</p>
                <article>
                  {ageform
                    .slice(0, 2)
                    .split("")
                    .map((char, index) => (
                      <span className="digit" key={index}>
                        <span className="hidden">0</span>
                        { <span className="char">{char}</span>}
                      </span>
                    ))}
                </article>
              </div>
              <span className="timer-separator">
                <span className="hidden">0</span>
                <span className="char">{":"}</span>
              </span>
              <div className="months">
                <p>Months</p>
                <article>
                  {ageform
                    .slice(3)
                    .split("")
                    .map((char, index) => (
                      <span className="digit" key={index}>
                        <span className="hidden">0</span>
                        <span className="char">{char}</span>
                      </span>
                    ))}
                </article>
              </div>
            </div>
          </div>
          <header>
            <p>When eGFR is dipping, the clock is ticking</p>
          </header>
          <div className="btn-container">
            <button
              onClick={() => {
                addAction(ageform);
                setVideoVisiblity(true);
              }}
            >
              Bring Protection To Life
            </button>
          </div>
        </section>
        {/* <Nav/> */}
      </section>
      <Video
        videoVisiblity={videoVisiblity}
        setVideoVisiblity={setVideoVisiblity}
      />
    </>
  );
}

export default App;
